import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 3C8.83 3 3 8.83 3 16s5.83 13 13 13 13-5.83 13-13S23.17 3 16 3m0 24C9.93 27 5 22.07 5 16S9.93 5 16 5s11 4.93 11 11-4.93 11-11 11"
    />
    <path
      fill="currentColor"
      d="M20 13c0-.92-.33-1.82-.91-2.53a4 4 0 0 0-2.3-1.38c-.9-.18-1.84-.05-2.66.38-.81.43-1.46 1.13-1.82 1.98-.22.51.02 1.1.53 1.31.51.22 1.1-.02 1.31-.53.18-.42.5-.78.91-.99s.88-.28 1.33-.19.86.34 1.15.69.45.8.45 1.27c0 .4-.12.78-.31 1.07l-5.49 7.33c-.23.3-.26.71-.09 1.05a1 1 0 0 0 .89.55h6c.55 0 1-.45 1-1s-.45-1-1-1h-4l4.31-5.76c.45-.66.69-1.44.69-2.24z"
    />
  </svg>
);
const SvgIconNumberCircleTwo = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconNumberCircleTwo);
export default Memo;
